import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_SERVER_API,
  prepareHeaders: (headers) => {
      try {
          // Retrieve tokens dynamically at request time
          const tokens = JSON.parse(sessionStorage.getItem("tokens")) || {};
          const api_key = JSON.parse(sessionStorage.getItem("api_key")) || {};

          if (tokens.access_token) {
              headers.set('Authorization', `Bearer ${tokens.access_token}`);
          }
          if (api_key.user_api_key) {
              headers.set('User_api_key', api_key.user_api_key);
          }
      } catch (error) {
          console.error("Error retrieving tokens:", error);
      }
      return headers;
  },
});

  
export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery,
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (credentials) => ({
        url: "/auth/register/",
        method: "POST",
        body: credentials,
      }),
    }),
    loginUser: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login/",
        method: "POST",
        body: credentials,
      }),
    }),
    acceptAgreement: builder.mutation({
      query: (body) => ({
        url: "/auth/accept_agreement/",
        method: "POST",
        body,
      }),
    }),
    logoutUser: builder.query({
      query: () => ({
        url: "/auth/logout/",
        method: "GET"
      }),
    }),

  }),
});
  
export const { 
  useRegisterUserMutation, 
  useLoginUserMutation,
  useAcceptAgreementMutation, 
  useLogoutUserQuery
} = authApi;